import { Component } from "@angular/core";

@Component({
  selector: "lib-info-icon",
  template: `<i class="ph-fill ph-info bg-white text-blue text-3xl rounded-full w-6 h-6 flex items-center justify-center"></i>`,
  styles: [':host { display: inline-block; }']
})
export class InfoIconComponent {}
